import React, { useEffect, useState } from "react";

const TrackingUpdateModal = ({
  show,
  onClose,
  onSave,
  orderGuid,
  currentTracking = null,
  isUpdating = false,
}) => {
  const [trackingData, setTrackingData] = useState({
    courierName: currentTracking?.courierName || "",
    trackingCode: currentTracking?.trackingCode || "",
    trackingLink: currentTracking?.trackingLink || "",
  });

  // Keep local state in sync when modal opens or when currentTracking updates
  useEffect(() => {
    setTrackingData({
      courierName: currentTracking?.courierName || "",
      trackingCode: currentTracking?.trackingCode || "",
      trackingLink: currentTracking?.trackingLink || "",
    });
  }, [currentTracking, show]);

  const handleChange = (field, value) => {
    setTrackingData((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  const handleSubmit = () => {
    if (
      trackingData.courierName.trim() &&
      trackingData.trackingCode.trim() &&
      trackingData.trackingLink.trim()
    ) {
      onSave(orderGuid, trackingData);
    }
  };

  const isValid =
    trackingData.courierName.trim() &&
    trackingData.trackingCode.trim() &&
    trackingData.trackingLink.trim();

  if (!show) return null;

  return (
    <div
      className="modal show d-block"
      tabIndex="-1"
      style={{ backgroundColor: "rgba(0,0,0,0.5)" }}
    >
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">
              <i className="mdi mdi-truck-delivery me-2"></i>
              {currentTracking ? "Update" : "Add"} Tracking Details
            </h5>
            <button
              type="button"
              className="btn-close"
              onClick={onClose}
              disabled={isUpdating}
            ></button>
          </div>

          <div className="modal-body">
            <div className="mb-3">
              <label className="form-label">
                Courier Name <span className="text-danger">*</span>
              </label>
              <input
                type="text"
                className="form-control"
                value={trackingData.courierName}
                onChange={(e) => handleChange("courierName", e.target.value)}
                placeholder="e.g., FedEx, DHL, Blue Dart, DTDC"
                disabled={isUpdating}
              />
            </div>

            <div className="mb-3">
              <label className="form-label">
                Tracking Code <span className="text-danger">*</span>
              </label>
              <input
                type="text"
                className="form-control"
                value={trackingData.trackingCode}
                onChange={(e) => handleChange("trackingCode", e.target.value)}
                placeholder="e.g., FX1234567890"
                disabled={isUpdating}
              />
            </div>

            <div className="mb-3">
              <label className="form-label">Tracking Link</label>
              <textarea
                className="form-control"
                rows="2"
                value={trackingData.trackingLink}
                onChange={(e) => handleChange("trackingLink", e.target.value)}
                placeholder="https://www.fedex.com/track/?trackingnumber=..."
                disabled={isUpdating}
              />
            </div>

            <div className="alert alert-info whitespace-normal">
              <small className="whitespace-normal">
                <strong>Note:</strong> Courier name, tracking code and tracking
                link are required.
              </small>
            </div>
          </div>

          <div className="modal-footer pt-2">
            <button
              type="button"
              className="btn btn-danger"
              onClick={onClose}
              disabled={isUpdating}
            >
              Cancel
            </button>
            <button
              type="button"
              className="btn btn-secondary"
              onClick={handleSubmit}
              disabled={!isValid || isUpdating}
            >
              {isUpdating ? (
                <>
                  <span className="action-spinner me-2"></span>
                  Updating...
                </>
              ) : (
                <>
                  <i className="mdi mdi-content-save fs-16"></i>
                  {currentTracking ? "Update" : "Add"} Tracking
                </>
              )}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};
export default TrackingUpdateModal;
